import React from 'react';
import { Box, Typography, Button, IconButton, Chip } from '@mui/material';
import { MdEdit, MdDeleteForever } from 'react-icons/md';

const SubcategoryCard = ({ subcategory, onEdit, onDelete }) => {
    return (
        <Box
            sx={{
                borderRadius: '8px',
                border: '1px solid #e2e8f0',
                backgroundColor: '#ffffff',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Box sx={{ position: 'relative', width: '100%', paddingBottom: '100%' }}>
                <img
                    src={subcategory.image || subcategory.linkId?.image || '/img/placeholder.png'}
                    alt={subcategory.linkId?.title || 'Subcategory'}
                    style={{ position: 'absolute', width: '100%', height: '100%', objectFit: 'cover' }}
                />
            </Box>
            <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <Typography sx={{ fontSize: '1rem', fontWeight: 600, color: '#0f172a' }}>
                    {subcategory.linkId?.title || 'Untitled'}
                </Typography>
                <Box display="flex" justifyContent="space-between" gap={1}>
                    <Chip
                        label={subcategory.linkId?.status || 'Unstatus'}
                        size="small"
                        color={subcategory.linkId?.status === 'active' ? 'success' : 'warning'}
                    />
                    <Box display="flex" justifyContent="flex-end" gap={1}>
                        <IconButton
                            onClick={() => onEdit(subcategory)}
                            sx={{ fontFamily: 'Mulish, sans-serif', textTransform: 'none' }}
                        >
                            <MdEdit style={{ color: '#1976d2', fontSize: '1.4rem' }} />
                        </IconButton>
                        <IconButton
                            color="error"
                            onClick={() => onDelete(subcategory)}
                            sx={{ fontFamily: 'Mulish, sans-serif', textTransform: 'none' }}
                        >
                            <MdDeleteForever style={{ color: '#d32f2f', fontSize: '1.4rem' }} />
                        </IconButton>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default SubcategoryCard;